import React, { useState } from "react";
import resel from "../../assets/Banner.png";
import BookingForm from '../common/BookingForm';
import { Helmet } from "react-helmet";

export const Resale = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
        <meta
          name="description"
          content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
        />
        <meta
          name="keywords"
          content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
        />
        <meta name="author" content="The Best Cab Jaipur" />
      </Helmet>
      <div
        className="relative w-full h-[400px] sm:h-[500px] bg-cover bg-center flex items-center justify-center sm:justify-end px-6 sm:px-10"
        style={{
          backgroundImage: `url(${resel})`,
        }}
      >
        {/* Overlay for better readability */}
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>

        <div className="relative text-white max-w-lg text-center sm:text-left">
          <h3 className="text-2xl sm:text-4xl font-bold mb-4">
            Book Your Ride Instantly
          </h3>
          <p className="text-base sm:text-lg mb-6">
            Get the best cab booking experience with our fast and reliable service.
            Travel comfortably with professional drivers and affordable rates.
          </p>
          <button
            className="bg-pink-600 hover:bg-pink-500 text-white font-semibold px-6 py-3 rounded-lg transition"
            onClick={(e) => {
              e.stopPropagation();
              setIsOpen(true);
            }}
          >
            Book Now
          </button>
        </div>

        <BookingForm isOpen={isOpen} setIsOpen={setIsOpen} />
      </div>
    </>
  );
}
